var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "system/warning_line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning_line"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 5.00033C10.4606 5.00033 10.8337 5.37342 10.8337 5.83366V10.8337C10.8337 11.2939 10.4606 11.667 10.0003 11.667C9.54009 11.667 9.16699 11.2939 9.16699 10.8337V5.83366C9.16699 5.37342 9.54009 5.00033 10.0003 5.00033Z",
    fill: "#0A1129",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.167C10.4606 14.167 10.8337 13.7939 10.8337 13.3337C10.8337 12.8734 10.4606 12.5003 10.0003 12.5003C9.54009 12.5003 9.16699 12.8734 9.16699 13.3337C9.16699 13.7939 9.54009 14.167 10.0003 14.167Z",
    fill: "#0A1129",
    fillOpacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 10.0003C1.66699 5.39795 5.39795 1.66699 10.0003 1.66699C14.6027 1.66699 18.3337 5.39795 18.3337 10.0003C18.3337 14.6027 14.6027 18.3337 10.0003 18.3337C5.39795 18.3337 1.66699 14.6027 1.66699 10.0003ZM10.0003 3.33366C6.31843 3.33366 3.33366 6.31843 3.33366 10.0003C3.33366 13.6822 6.31843 16.667 10.0003 16.667C13.6822 16.667 16.667 13.6822 16.667 10.0003C16.667 6.31843 13.6822 3.33366 10.0003 3.33366Z",
    fill: "#0A1129",
    fillOpacity: 0.65
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLine);
export default __webpack_public_path__ + "static/media/warning_line.62e50fa792d1c5cc7f3f20b47018dfff.svg";
export { ForwardRef as ReactComponent };